import { render, staticRenderFns } from "./VuiChoiGiaiTriForm.vue?vue&type=template&id=6d56f5e3"
import script from "./VuiChoiGiaiTriForm.vue?vue&type=script&lang=js"
export * from "./VuiChoiGiaiTriForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports